import { TUserShelf } from "../../utils/@types/store"

const userShelf = (): TUserShelf => {
  return null
}

export default userShelf
